"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateStatusDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const swagger_1 = require("@nestjs/swagger");
class UpdateStatusDto {
}
exports.UpdateStatusDto = UpdateStatusDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Notification Id.",
        example: "id:2",
    }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], UpdateStatusDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Updating Notification status.",
        example: "status:NOTIFICATION_DELETE",
    }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], UpdateStatusDto.prototype, "status", void 0);
